export default {
  title: {
    id: 'product_page_other_sellers_drawer_title',
    defaultMessage: 'Other offers',
  },
  closeButtonLabel: {
    id: 'product_page_other_sellers_drawer_close_button_label',
    defaultMessage: 'Close the other offers',
  },
  allOffersFor: {
    id: 'product_page_other_sellers_drawer_all_offers_for',
    defaultMessage: 'All offers for {productName, html}',
  },
  selectedOptionsIntro: {
    id: 'product_page_other_sellers_drawer_selected_options_intro',
    defaultMessage: 'All offers below come with your selected options:',
  },
  deliveryInDaysRange: {
    id: 'product_page_other_sellers_drawer_delivery_in_days_range',
    defaultMessage: 'Arrives within {minDays}-{maxDays} days',
  },
  refurbishedBy: {
    id: 'product_page_other_sellers_drawer_refurbished_by',
    defaultMessage: 'Refurbished by {sellerName, html}',
  },
  rating: {
    id: 'product_page_other_sellers_drawer_rating',
    defaultMessage: '{rating}/5',
  },
  selectOffer: {
    id: 'product_page_other_sellers_drawer_select_offer',
    defaultMessage: 'Select offer',
  },
  currentlySelected: {
    id: 'product_page_other_sellers_drawer_currently_selected',
    defaultMessage: 'Currently selected',
  },
  comingSoonTitle: {
    id: 'product_page_other_sellers_drawer_coming_soon_title',
    defaultMessage: 'This feature is coming soon...',
  },
  comingSoonDescription: {
    id: 'product_page_other_sellers_drawer_coming_soon_description',
    defaultMessage:
      'We’re working on a new way to give you the power to choose your seller on Back Market. It’s not ready yet, so stay tuned.',
  },
  feedbackQuestion: {
    id: 'product_page_other_sellers_drawer_feedback_question',
    defaultMessage: 'What would make you choose a different offer?',
  },
  feedbackPrice: {
    id: 'product_page_other_sellers_drawer_feedback_price',
    defaultMessage: 'Price',
  },
  feedbackSeller: {
    id: 'product_page_other_sellers_drawer_feedback_seller',
    defaultMessage: 'Seller',
  },
  feedbackSellerRating: {
    id: 'product_page_other_sellers_drawer_feedback_seller_rating',
    defaultMessage: 'Seller rating',
  },
  feedbackDeliverySpeed: {
    id: 'product_page_other_sellers_drawer_feedback_delivery_speed',
    defaultMessage: 'Delivery speed',
  },
  feedbackNotUse: {
    id: 'product_page_other_sellers_drawer_feedback_not_use',
    defaultMessage: 'I wouldn’t use this feature',
  },
  feedbackOther: {
    id: 'product_page_other_sellers_drawer_feedback_other',
    defaultMessage: 'Other',
  },
  sendAnswer: {
    id: 'product_page_other_sellers_drawer_send_answer',
    defaultMessage: 'Send answer',
  },
  textareaLabel: {
    id: 'product_page_other_sellers_drawer_textarea_label',
    defaultMessage: 'Please specify',
  },
  textareaPlaceholder: {
    id: 'product_page_other_sellers_drawer_textarea_placeholder',
    defaultMessage: 'Tell us what would make you choose another offer...',
  },
  selectionRequiredError: {
    id: 'product_page_other_sellers_drawer_selection_required_error',
    defaultMessage: 'Please select at least one option',
  },
  commentRequiredError: {
    id: 'product_page_other_sellers_drawer_comment_required_error',
    defaultMessage: 'Please fill in the text field for Other',
  },
  thankYouFeedback: {
    id: 'product_page_other_sellers_drawer_thank_you_feedback',
    defaultMessage: 'Thank you for your feedback!',
  },
}
